<style lang="scss" rel="stylesheet/scss">
@import "@/scss/color";

.module-summary {
    display: flex;
    width: 100%;
    justify-content: center;
    margin-top: 5px;
    margin-bottom: 8px;

    .module-item {
        border-radius: 50%;
        background-color: white;
        border: 3px solid $module-summary-circle;
        width: 15px;
        height: 15px;
        margin-right: 15px;
        box-sizing: border-box;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;

        &.locked {
            border-color: $module-summary-circle-locked;
        }

        &.complete {
            background-color: $module-summary-circle;
        }

        &.active {
            background-color: transparent;

            .inner {
                border-radius: 50%;
                box-sizing: border-box;
                width: 7px;
                height: 7px;
                background-color: $module-summary-circle;
            }
        }

        .hover-text {
            font-size: 13px;
            line-height: 1.3;
            text-align: center;
            position: absolute;
            top: 15px;
            margin: auto;
            left: 50%;
            transform: translateX(-50%);
            white-space: nowrap;
        }
    }

    .module-item:last-child {
        margin-right: 0;
    }

    @media (max-width: 767px) {
        margin-top: 10px;

        .module-item {
            border-width: 1.5px;
            width: 10.5px;
            height: 10.5px;
            margin-right: 7.5px;

            &.active {
                .inner {
                    width: 6.5px;
                    height: 6.5px;
                }
            }

            .hover-text {
                font-size: 8px;
                line-height: 1.3;
                width: 60px;
                top: 15px;
            }
        }
    }
}
</style>

<template>
    <div class="module-summary">
        <div
            v-for="(module, index) in modules"
            :class="[
                'module-item',
                { locked: module.locked },
                { complete: module.completed_at !== null },
                { active: activeModuleId === module.id }
            ]"
            @click="setActiveModule(module, index)"
            @touchmove.stop=""
            @mouseover="showTitle(module, index)"
            @mouseout="hideTitle(module, index)"
        >
            <div class="inner"></div>
            <div
                class="hover-text"
                v-show="titleIndex === index"
                v-html="module.title"
            ></div>
        </div>
    </div>
</template>

<script type="text/babel">
export default {
    name: "module-summary",
    props: ["activeModuleId", "modules"],
    data() {
        return {
            titleIndex: null
        };
    },
    methods: {
        setActiveModule(module, index) {
            if (!module.locked) {
                this.$emit("changeModule", index);
            }
        },
        showTitle(module, index) {
            this.titleIndex = index;
        },
        hideTitle(module, index) {
            this.titleIndex = null;
        }
    }
};
</script>
